import GrowthReferralsComponent from '../Components/Growth/GrowthReferralsComponent';

function GrowthReferralsPage() {
  return <GrowthReferralsComponent />;
}

export default GrowthReferralsPage;